import globalAgent from 'src/agent';
import { URLS } from 'src/constants/urls';

export interface ILeadExample {
    id: number;
    text: string;
    source: string;
    date: string;
    category: string;
    category_icon?: string;
    keywords: string[];
    isSelected?: boolean;
}

export interface INicheAnalysisRequest {
    service_description: string;
    project_goal: string;
    project_id: number; // ID проекта, в который сохранять анализ
    use_geolocation?: boolean;
    selected_locations?: Array<{ name: string; [key: string]: any }>;
}

export interface IRecommendedCollection {
    id: number;
    name: string;
    city?: string | null;
    tags: string[];
    chat_count: number;
}

export interface INicheAnalysisResponse {
    keywords: string[];
    lead_examples: ILeadExample[];
    recommended_collections: {
        city_collections: IRecommendedCollection[];
        general_collections: IRecommendedCollection[];
    };
    analysis_summary: string;
    category?: string;
    project_id: number; // ID проекта, в который сохранен анализ
}

class NicheAnalysisService {
    queryKey = 'niche-analysis';

    async analyzeNiche(data: INicheAnalysisRequest): Promise<INicheAnalysisResponse> {
        try {
            const response = await globalAgent.post(URLS.NICHE_ANALYSIS, data);
            return response.data;
        } catch (error) {
            console.error('Ошибка анализа ниши:', error);
            throw error;
        }
    }

    async getLeadExamples(keywords: string[]): Promise<ILeadExample[]> {
        try {
            const response = await globalAgent.get(URLS.LEAD_EXAMPLES, {
                params: { keywords: keywords.join(',') },
            });
            return response.data;
        } catch (error) {
            console.error('Ошибка получения примеров лидов:', error);
            throw error;
        }
    }
}

export default new NicheAnalysisService();
